import { ALGOS_E } from "@constants/Algos";
import { PostRequest } from "./http/BaseRequest";
import { IPoolCreds } from "./getSettings";
import { IAdminMinerProof, IMiningPlanOptions, IReproxyLink, MinerLocationRaw, NoteI } from "./getMinerList";
import { IMinerMeta } from "./changeMinerSettings";
import { MinerChatMessage } from "./http/miners/dto";
import { BaseResponse, MinerTabType } from "./http/responses/BaseResponse";
import { IMinerProfileBase } from "./minerProfiles";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";


export interface IMinerInfoSetting {
  id: number;
  user_id: number;
  email: string;
  name: string;
  hash: ALGOS_E
  Pools: IPoolCreds[];
  used_count: number;
  is_default: boolean;
}

export interface BaseMinerAdditionalDataI {
  admin_notes?: NoteI[];
  user_note?: string;
  notifications: string[];
  plan: IMiningPlanOptions;
  smooth?: boolean;
}

export interface ReceivedMinerInfoI extends BaseMinerAdditionalDataI {
  Id: number;
  location?: MinerLocationRaw;
}

export interface IMinerAdditionalData extends BaseMinerAdditionalDataI {
  location_raw?: MinerLocationRaw;
  photos?: string[];
  meta?: IMinerMeta;
  chat: MinerChatMessage[];
}

export interface IAdminMinerAdditionalData {
  admin_note: string;
  sync_note: string;
  proof: number; // mining admin %
  admin_mining_proof?: IAdminMinerProof[];
  admin_mining_setting?: string;
  photos?: string[];
  meta?: IMinerMeta;
  chat: MinerChatMessage[];
  uuid?: string;
  contract_id?: number;
  contract_name?: string;
  installed?: string;
  reproxy_link?: IReproxyLink;
  /// 
  customer_id?: string;
  customer_email?: string;
  customer_name?: string;
  customer_uuid?: string;
}

interface IAdminMinerInfoSettings {
  all_settings?: IMinerInfoSetting[];
}

export interface IAdminMinerTable extends IMinerAdditionalData, IAdminMinerAdditionalData, IAdminMinerInfoSettings {
  id: number;
  miner_id: string;
  unknown_miner_id?: string;
  profile: IMinerProfileBase;
  hash: ALGOS_E;
  speed_default: number;
  speed_current: number;
  accepted?: number;
  rejected?: number;
  speed_drop: number;
  setting: string;
  settingid: number;
  status: MINER_STATUSES_E;
  location: string;
  location_id: string;
  tags?: string;
  user_color?: string;
  node?: string;
  ///
  customer_uuid?: string;
  customer_id?: string;
  customer_email?: string;
  customer_name?: string;
  admin_mining_do?: boolean;
  has_errors?: boolean;
  readonly isSelected?: boolean;
  readonly tab: MinerTabType;
  readonly is_own_mining: boolean;
}

export interface IUnknownMinerOrig {
  // created, login, agent, ip, mac
  id: number;
  description: string;
  created: number;
}

export type IAdminMinerTableOrig = IAdminMinerTable | IUnknownMinerOrig;

export interface IAdminMinerInfo extends ReceivedMinerInfoI,
  IAdminMinerAdditionalData, IAdminMinerInfoSettings {

}

export class GetMinerInfo extends PostRequest {
  constructor(id: string, admin?: boolean) {
    const params: any = { id, full: true };
    super(`/${admin ? "admin" : "user"}/miner/info`, params);
  }
}


export interface RecievedFullMinerInfo
  extends Omit<IAdminMinerTable, "location">,
  IAdminMinerInfo { }

export interface FullMinerInfoResponse extends BaseResponse {
  readonly Record: RecievedFullMinerInfo;
}

export class GetFullMinerInfo extends PostRequest {
  constructor(id: string, admin?: boolean) {
    const params: any = { id, full: true };
    super(`/${admin ? "admin" : "user"}/miner/info`, params);
  }
}